import { InternalEvent } from '../event';
import StructuredCollection from './structured-collection';
var CollectionManager = /** @class */ (function () {
    function CollectionManager(storage, eventBus) {
        this.collectionMap = new Map();
        this.storage = storage;
        this.eventBus = eventBus;
    }
    CollectionManager.prototype.getCollection = function (name, contextGenerator) {
        if (this.collectionMap.has(name)) {
            return this.collectionMap.get(name);
        }
        var collection = this.createCollection(name, contextGenerator);
        this.collectionMap.set(name, collection);
        this.eventBus.emit(InternalEvent.CollectionCreated, {
            collectionName: name,
            context: contextGenerator.spawnContext(),
        });
        return collection;
    };
    CollectionManager.prototype.createCollection = function (name, contextGenerator) {
        var collectionAspects = this.storage.aspects.collection;
        return new StructuredCollection(name, { contextGenerator: contextGenerator, aspects: collectionAspects });
    };
    return CollectionManager;
}());
export default CollectionManager;
//# sourceMappingURL=collection-manager.js.map